import { vHighlight } from '~/directives/vHighlight'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('highlight', vHighlight)
})
